import { Component, Input, OnInit } from '@angular/core';
import { KlaHttpService } from '../services/kla.http.service';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SafeHtmlPipe } from '../safe-html/safe-html';
import { MatTableModule } from '@angular/material/table';
import { DynamicContentComponent } from 'app/shared/dynamic-content/dynamic-content.component';

@Component({
  selector: 'kla-new-action-taxonomy-action',
  templateUrl: './new-action-taxonomy-action.component.html',
  styleUrls: ['./new-action-taxonomy-action.component.scss'],
  standalone: true,
  imports: [ CommonModule, MatTooltipModule, DynamicContentComponent, MatTableModule ]
})
export class NewActionTaxonomyActionComponent implements OnInit {

  @Input() actions;
  @Input() includeTier;
  @Input() color;
  @Input() goalChild;
  @Input()
  public config: any;

  constructor(
    private httpService: KlaHttpService
  ) { }

  get status() {
    return
  }

  get columnsActive() {
    return this.config.columnsActive;
  }

  ngOnInit(): void {
  }

  get isMobile() {
    return window.innerWidth < 992;
  }

  isTabletPortrait() {
    return window.innerWidth < 1023;
  }

  isiOS() {
    const iDevices = [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ];

    if (!!navigator.platform) {
      while (iDevices.length) {
        if (navigator.platform === iDevices.pop()) {
          return true;
        }
      }
    }

    return false;
  }

  applyCoBenefitsStyles() {
    const existingStyle = document.getElementById('panel-mat-tooltip');
    if (typeof (existingStyle) != 'undefined' && existingStyle != null) {
      existingStyle.remove();
    }
    const style = document.createElement('style');
    const isiOS = this.isTabletPortrait() && this.isiOS();
    const cloudImgPath = (isiOS) ? '/assets/action-plan-icons/flipped-rotated-cloud-dialog.png' : '/assets/action-plan-icons/cloud-dialog.png';
    const bgPosition = (isiOS) ? 'top' : 'bottom';
    style.id = 'panel-mat-tooltip';
    style.innerHTML = `.mat-tooltip {
      background: transparent url(${cloudImgPath}) 0% 0% no-repeat padding-box !important;
      font-size: 11px !important;
      font-weight: bold !important;
      background-size: contain !important;
      background-position: ${bgPosition} !important;
      font-family: 'OpenSans' !important;
      padding: 30px 30px 60px 30px!important;
      color: ${this.color} !important;
      max-width: 215px !important;
      overflow: hidden !important;
      text-overflow: ellipsis !important;
      border-radius: 4px;
      margin: unset;
      margin-bottom: 15px;
      margin-left: -30px;
      aspect-ratio: 225/125;
      line-height: 1.5;
      text-align: center;
    }
    .mat-tooltip-panel {
       -webkit-transform: translate(-20px, 25px) !important;
        transform: translate(-20px, 25px) !important;
        pointer-events: none !important;
    }
    .cdk-overlay-pane {
      position: fixed !important;
      box-sizing: border-box;
      max-width: 100%;
      max-height: 100%;
    }
    `;
    document.getElementsByTagName('head')[0].appendChild(style);
  }

  applyStatusStyles() {
    const existingStyle = document.getElementById('panel-mat-tooltip');
    if (typeof (existingStyle) != 'undefined' && existingStyle != null) {
      existingStyle.remove();
    }
    const style = document.createElement('style');
    const isiOS = this.isTabletPortrait() && this.isiOS();
    const cloudImgPath = (isiOS) ? '/assets/action-plan-icons/flipped-rotated-cloud-dialog.png' : '/assets/action-plan-icons/cloud-dialog.png';
    const bgPosition = (isiOS) ? 'top' : 'bottom';
    style.id = 'panel-mat-tooltip';
    style.innerHTML = `.mat-tooltip {
      background: transparent url(${cloudImgPath}) 0% 0% no-repeat padding-box !important;
      font-size: 11px !important;
      font-weight: bold !important;
      background-size: contain !important;
      background-position: ${bgPosition} !important;
      font-family: 'OpenSans' !important;
      color: ${this.color} !important;
      padding: 20px 30px !important;
      aspect-ratio: 235/113;
      line-height: 0.5;
    }
    .mat-tooltip-panel {
       -webkit-transform: translate(-20px, 25px) !important;
        transform: translate(-20px, 25px) !important;
    }
    .cdk-overlay-pane {
      position: fixed !important;
    }
    `;
    document.getElementsByTagName('head')[0].appendChild(style);
  }



  getCoBenefitImage(title) {
    let value = title?.title ? title.title : title
    if(this.config.list.find(x => x.title == value)) {
      return this.config.list.find(x => x.title == value).image?.url;
    }
  }

  getCoBenefitImageAlt(title) {
    let value = title?.title ? title.title : title
    if(this.config.list.find(x => x.title == value)) {
      return this.config.list.find(x => x.title == value).image?.alt;
    }
  }

  getCoBenefitImageTitle(title) {
    return title?.title ? title.title : title;
  }

}
